import { useContext } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import initValue from '@/returns/pages/TransactionRMAPage/context/initValue'
import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import returnsServices from '@/returns/services/services'

import { getCreateReturnPayload } from './helpers'

const useReturn = ({ setToastInfo, returnPortalId, handleChargebackError }) => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)

  const { loading: creatingRma, fetchData: createRma } = useFetch(returnsServices.createRma, {
    doInitialRequest: false,
  })

  const { loading: updatingRma, fetchData: updateRma } = useFetch(returnsServices.updateRma, {
    doInitialRequest: false,
  })

  const handleUpdateRma = async items => {
    if (items?.length > 0) {
      try {
        const data = await updateRma({
          returnId: rmaInfo.orderInfo.returnId,
          orderId: rmaInfo.orderInfo.id,
          payload: getCreateReturnPayload(items, returnPortalId),
        })

        setRmaInfo(rmaInfo => ({
          ...rmaInfo,
          summaryLineItems: data.line_items || [],
          orderInfo: {
            ...rmaInfo.orderInfo,
          },
          orderAmount: data?.summary,
        }))
        return data
      } catch (err) {
        if (handleChargebackError(err)) return

        setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
      }
    } else {
      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        summaryLineItems: [],
        orderInfo: {
          ...rmaInfo.orderInfo,
          returnId: null,
          deliveryMethod: null,
          allowed_refund_methods: [],
        },
        orderAmount: initValue.orderAmount,
      }))
    }
  }

  const handleCreateRma = async items => {
    try {
      const data = await createRma({
        orderId: rmaInfo.orderInfo.id,
        payload: getCreateReturnPayload(items, returnPortalId),
      })

      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        orderInfo: {
          ...rmaInfo.orderInfo,
          returnId: data.id,
          deliveryMethod: data?.delivery_method,
          allowed_refund_methods: data?.allowed_refund_methods,
        },
        orderAmount: data?.summary,
      }))
      return data
    } catch (err) {
      if (handleChargebackError(err)) return

      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  return {
    createRma: handleCreateRma,
    updateRma: handleUpdateRma,
    loading: creatingRma || updatingRma,
  }
}

export default useReturn
